import React from 'react';
import { Checkbox } from '@components/atoms/Checkbox';
import { cn } from '@utils/cn';

interface TaskTableHeaderProps {
  totalTasks?: number;
  pendingTasks?: number;
  showApprovalFilter?: boolean;
  approvalFilterChecked?: boolean;
  onApprovalFilterChange?: (checked: boolean) => void;
  className?: string;
}

export const TaskTableHeader: React.FC<TaskTableHeaderProps> = ({
  totalTasks = 0,
  pendingTasks = 0,
  showApprovalFilter = false,
  approvalFilterChecked = false,
  onApprovalFilterChange,
  className = '',
}) => {
  return (
    <div className={cn(
      'flex justify-between items-center p-6 bg-gradient-to-r from-slate-50 to-blue-50 dark:from-gray-800 dark:to-gray-700 border-b border-gray-200 dark:border-gray-600 rounded-t-xl',
      className
    )}>
      <div className="flex items-center space-x-3">
        <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
          <span className="text-white text-sm font-bold">📊</span>
        </div>
        <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">
          Task & Event Management
        </h2>
      </div>

      <div className="flex items-center space-x-6">
        <div className="flex items-center space-x-2 bg-white dark:bg-gray-600 px-3 py-1 rounded-full shadow-sm">
          <span className="text-blue-600 text-sm">📋</span>
          <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
            {totalTasks} Total Items
          </span>
        </div>
        <div className="flex items-center space-x-2 bg-orange-50 dark:bg-orange-900/20 px-3 py-1 rounded-full">
          <span className="text-orange-600 text-sm">⏳</span>
          <span className="text-sm font-medium text-orange-700 dark:text-orange-300">
            {pendingTasks} Pending
          </span>
        </div>

        {showApprovalFilter && (
          <div className="flex items-center space-x-2 bg-gray-50 dark:bg-gray-600 px-3 py-1 rounded-full">
            <Checkbox
              checked={approvalFilterChecked}
              onChange={onApprovalFilterChange}
              label="Awaiting Approval"
              className="text-sm font-medium text-gray-700 dark:text-gray-200"
            />
          </div>
        )}
      </div>
    </div>
  );
};